import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  getMilestoneSettings,
  saveMilestoneSettings,
} from "../../api/process";
import MilestoneSelector from "../../components/process/MilestoneSelector";
import { Info } from "lucide-react";
import PageHeader from "../../components/common/ui/PageHeader";

export default function MilestoneManager() {
  const { id: projectId } = useParams();

  const [milestones, setMilestones] = useState([]);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(true);

  // =========================================
  // 데이터 로드
  // =========================================
  useEffect(() => {
    async function load() {
      setLoading(true);
      try {
        const data = await getMilestoneSettings(projectId);

        setMilestones(Array.isArray(data) ? data : data.results || []);
        setSelected(
          (Array.isArray(data) ? data : data.results || [])
            .filter((m) => m.visible)
            .map((m) => m.id)
        );
      } catch (err) {
        console.error("마일스톤 로드 실패:", err);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, [projectId]);

  // 저장
  const handleSave = async () => {
    try {
      await saveMilestoneSettings(selected);
      alert("마일스톤 표시 설정이 저장되었습니다.");
    } catch (err) {
      console.error(err);
      alert("저장 중 오류 발생");
    }
  };

  if (loading) return <p className="p-6 text-gray-500">로딩 중...</p>;

  // =========================================
  // WBS 그룹화
  // =========================================
  const groupedByWBS = Object.values(
    milestones.reduce((acc, m) => {
      const wbs = m.wbs_code || "Unassigned";
      if (!acc[wbs]) {
        acc[wbs] = {
          wbs_code: wbs,
          wbs_name: wbs.split(".").slice(-1)[0] || wbs,
          milestones: [],
        };
      }
      acc[wbs].milestones.push({
        id: m.id,
        code: m.activity_code,
        name: m.name,
      });
      return acc;
    }, {})
  );

  // =========================================
  // UI
  // =========================================
  return (
    <div className="p-6 space-y-6">

      {/* 헤더 */}
      <PageHeader>마일스톤 관리</PageHeader>

      {/* 설명 박스 */}
      <div className="bg-blue-50 border border-blue-100 text-blue-700 p-4 rounded-xl flex gap-3">
        <Info className="w-5 h-5 mt-[2px]" />
        <p className="text-sm leading-relaxed">
          선택된 마일스톤은{" "}
          <span className="font-semibold">MTA 분석</span>과{" "}
          <span className="font-semibold">대시보드의 마일스톤 스케줄</span>에 표시됩니다.
          <br />
          체크 해제된 마일스톤은 시각화 및 차트에 나타나지 않습니다.
        </p>
      </div>

      {/* 마일스톤 선택 UI */}
      <div className="bg-white border rounded-lg p-5">
        <MilestoneSelector
          milestones={groupedByWBS}
          selected={selected}
          onChange={setSelected}
        />
      </div>

      {/* 저장 버튼 */}
      <div className="text-right">
        <button
          onClick={handleSave}
          className="btn-save"
        >
          변경사항 저장
        </button>
      </div>
    </div>
  );
}
